import React, { useState } from 'react';

const BlackButton = ({ 
  children, 
  onClick, 
  disabled = false, 
  type = 'button',
  style = {},
  className = ''
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const buttonStyle = {
    backgroundColor: disabled ? '#6b7280' : (isHovered ? '#374151' : '#1f2937'),
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    padding: '10px 20px',
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'all 0.3s ease',
    opacity: disabled ? 0.6 : 1,
    transform: isHovered && !disabled ? 'translateY(-1px)' : 'translateY(0)',
    boxShadow: isHovered && !disabled ? '0 4px 8px rgba(0, 0, 0, 0.2)' : '0 2px 4px rgba(0, 0, 0, 0.1)',
    outline: 'none',
    ...style
  };

  return (
    <button
      style={buttonStyle}
      onClick={onClick}
      disabled={disabled}
      type={type}
      className={className}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
    </button>
  );
};

export default BlackButton;
